export const RPC_URL_MAINNET = "https://api.mainnet-beta.solana.com"
export const RPC_URL_SERUM = "https://solana-api.projectserum.com"

export const RPC_URL = RPC_URL_MAINNET;
export const PROGRAM_ID ="TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"

export const META_PUBKEY = "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s"
